import type { CatalogEntry } from '../types';

/**
 * Preferences (feature `14`) error codes + catalog.
 *
 * Code shape is `14AAEE` (decimal, zero-padded):
 *   - `AA` = endpoint within the feature (`00` = feature-level / cross-endpoint).
 *   - `EE` = specific condition within that endpoint.
 *
 * Endpoint → `AA` map:
 *   columns=01 (GET/PUT /preferences/columns/:tableKey).
 *
 * The column-preference store is column-agnostic — it persists an opaque ordered
 * id list per `tableKey`. The only server-side guard is the `tableKey` allowlist;
 * an unknown table is the single condition for this feature.
 */
export const PREFERENCES_CODES = {
  /** Column-preference endpoints (columns=01). */
  Columns: {
    UnknownTable: '140101',
  },
} as const;

export const PREFERENCES_CATALOG: Record<string, CatalogEntry> = {
  // ── Column preferences ──
  '140101': {
    httpStatus: 400,
    message: "We couldn't save your column layout for this table.",
  },
};
